module.exports = __webpack_public_path__ + "static/img/3i.231fafc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3i.jpg
// module id = VG8L
// module chunks = 0